import { useRef, useEffect } from 'react';
import { useLocale } from 'next-intl';

//* Styles
import WhyChooseUsSectionStyle from './style';

//* Components
import Text from '@/components/Text';
import Container from '@/components/Container';
import useTrigger from '@/components/Animation/useTrigger';
import TextAnimation from '@/components/Animation/TextAnimation/TextAnimation';

//* SVG
import { iconWhyChoose } from './util';

//* Data
import { dataWhyChooseUs } from '@/data';

const WhyChooseUsSection = () => {
	const lang = useLocale();

	//! Refs
	const titleRef = useRef();
	const styleRef = useRef();

	useEffect(() => {
		const trigger = useTrigger({
			ref: titleRef.current,
			documentPercent: 90,
			onEnter: () => {
				titleRef.current.children[0].classList.add('active');
				styleRef.current.classList.add('active');
			},
		});

		return () => {
			trigger();
		};
	}, []);

	return (
		<WhyChooseUsSectionStyle ref={styleRef}>
			<Container isSection>
				<Text
					tag={'h2'}
					ref={titleRef}
					className={'h3 font-montserrat-arm-medium uppercase text-section-title text-primary-color'}>
					<TextAnimation
						delay={0.2}
						text={dataWhyChooseUs[lang].title}
					/>
				</Text>

				<Container
					row
					full>
					<Text className={'p2 col-6 col-t-8 col-m-12 description-text'}>{dataWhyChooseUs[lang].description}</Text>
				</Container>

				<div className='wrapper-cart'>
					{dataWhyChooseUs[lang].items.map((item, index) => {
						return (
							<div
								style={{ '--delayItem': index }}
								key={index}
								className='icon-text-wrapper'>
								<div className='icon-inner-text-wrapper'>
									{iconWhyChoose[index] || null}
									<div className='wrapper-title-icon'>
										<Text>{item.title}</Text>
									</div>
								</div>
							</div>
						);
					})}
				</div>
			</Container>
		</WhyChooseUsSectionStyle>
	);
};

export default WhyChooseUsSection;
